import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../services/i18nService';
import alertStyles from './alertTemplate.scss';

const ConnectivityAlert = React.memo(({ model, extraClasses, handleClose, styles }) => {
    return (
        <div className={extraClasses} style={styles} role="alertdialog">
            <h3 className={alertStyles.connectivityAlertHeader}>
                {model.subject}
            </h3>
            <p className={alertStyles.connectivityAlertBody}>{model.body}</p>
            <button className={`${alertStyles.closeBtn} btn btn-message-close`} onClick={handleClose}>
                {t('general.close')}
            </button>
        </div>
    );
});

ConnectivityAlert.propTypes = {
    model: PropTypes.object.isRequired,
    extraClasses: PropTypes.string,
    handleClose: PropTypes.func,
    styles: PropTypes.object,
};

export default ConnectivityAlert;
